// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BwQmk","pageTitle":"styles_pageTitle__2w9p8","breadcrumbs":"styles_breadcrumbs__o6h4A"};